import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import PresentationTitle from '../PresentationTitle/PresentationTitle'
import RankingResult from '../RankingResult/RankingResult'
import Question from '../Question/Question'
import EditorTimer from '../../molecules/EditorTimer/EditorTimer'
import { QuizType } from '../../../../commons/EditorStatus'
import './EditorPreview.css'

const EditorPreview = ({
  eventTitle,
  eventImage,
  question,
  index,
  type,
  updateQuestions,
  canIntervalUpdate,
  lastUpdateTime
}) => {
  let header_text = ''
  let content = ''
  {
    switch (type) {
      case QuizType.FIRSTPAGE.value:
        header_text = QuizType.FIRSTPAGE.label
        content = <PresentationTitle participantCount={100} title={eventTitle} image={eventImage} shareUrl={'hoge'} />
        break
      case QuizType.QUESTION.value:
        header_text = `第${index}問`
        content = <Question question={question} index={index} showAnswer={true} />
        break
      case QuizType.RANKING.value:
        header_text = QuizType.RANKING.label
        content = <RankingResult rank={1} name="テストユーザー" correctCount={4} time={1.0} />
        break
    }
  }

  return (
    <div styleName="container">
      <div styleName="preview-header">
        <div styleName="preview-header-title">
          <p>{header_text}</p>
        </div>
        <EditorTimer isEnabled={canIntervalUpdate} timerFunction={updateQuestions} lastUpdateTime={lastUpdateTime} />
      </div>
      <div styleName="preview-display">
        <div styleName="transform-view">{content}</div>
      </div>
    </div>
  )
}

EditorPreview.propTypes = {
  eventTitle: PropTypes.string,
  eventImage: PropTypes.string.isRequired,
  question: PropTypes.object,
  index: PropTypes.number.isRequired,
  type: PropTypes.number.isRequired,
  updateQuestions: PropTypes.func.isRequired,
  canIntervalUpdate: PropTypes.bool.isRequired,
  lastUpdateTime: PropTypes.object
}

export default compose(pure)(EditorPreview)
